<form 
        (ngSubmit)="$event.preventDefault(); saveBehavior();"
        [formGroup]="hebahaviorForm"
        class="w-full h-full flex flex-col items-center justify-start gap-4 overflow-y-auto"
    >
    <div class="w-full overflow-y-auto px-1">                    
        <h2 class="pb-2 w-full oswald-font text-xl font-medium text-start">
            Behavior
        </h2>
        <div class="w-full flex flex-col items-center gap-4 pb-4"> 
            <div class="w-full flex flex-col items-start text-start" *ngFor="let question of questionList">
                <div class="w-full font-semibold">
                    <p>{{ question.question }}</p>
                </div>
                <div class="w-full flex flex-col items-center">
                    <textarea 
                        [formControlName]="question.formControlName"
                        rows="3"
                        class="block p-2 w-full text-sm text-gray-900 bg-gray-50 rounded border border-gray-300"
                        placeholder="Type here"
                    ></textarea>
                </div>
            </div>
        </div>

        <div class="w-full flex flex-row gap-2 items-center justify-end">
            <button
                type="submit"
                class="w-20 flex items-center justify-center px-4 py-1.5 rounded-md border bg-gradient-to-b oswald-font text-white"
                [ngClass]="{
                    'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': this.hebahaviorForm.invalid,
                    'border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200': this.hebahaviorForm.valid
                }"
                [disabled]="this.hebahaviorForm.invalid"
            >
                Save
            </button>
        </div>
    </div>
</form>